import { MainFilterInterface } from 'modules/main/types/main-filter-interface'
import {
  MainEventsApiInterface,
  MainLeadsInterface,
  MainRevenueInterface,
} from 'modules/main/types/main-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { LimitType } from 'shared/types/pagination-interface'
import useSWR from 'swr'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export const MAIN_API = '/api/dashboard/customer/main-dashboard'

const EVENTS_LIMIT: LimitType = 25

export function useMain(filter: MainFilterInterface) {
  const { user } = useUser()
  const { fetcher: leadsFetcher } = useFetch<RequestMethodsEnum.get, MainLeadsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { fetcher: eventsFetcher } = useFetch<RequestMethodsEnum.get, MainEventsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { fetcher: revenueFetcher } = useFetch<RequestMethodsEnum.get, MainRevenueInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.dateSince !== null ? `&filter[dateSince]=${filter.dateSince}` : ''}${
    filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ''
  }`

  const { data: leads } = useSWR<MainLeadsInterface>(
    () => {
      if (user && filter.dateTill !== null && filter.dateSince !== null) {
        return [`${MAIN_API}/leads?${filterApi}`, user]
      }
      return null
    },
    ([url]) => leadsFetcher(url),
  )

  const { data: events } = useControlledSwr(() => {
    if (user) {
      return [
        `${MAIN_API}/events?pagination[order]=next&pagination[limit]=${EVENTS_LIMIT}`,
        user,
        RequestModuleEnum.Contacts,
      ]
    }
    return null
  }, eventsFetcher)

  const { data: revenue } = useSWR(
    () => {
      if (user && filter.dateTill !== null && filter.dateSince !== null) {
        return [`${MAIN_API}/revenue?${filterApi}`, user]
      }
      return null
    },
    ([url]) => revenueFetcher(url),
  )

  return { leads, events, revenue }
}
